import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FleetFuelIdlenessReport } from 'src/app/models/dtos/fleet-fuel-idleness-report';
import { FleetFuelIdlenessService } from 'src/app/services/fleet-fuel-idleness.service';
import { MessageUtil } from 'src/app/utils/message.util';

@Component({
  selector: 'app-fleet-fuel-idleness',
  templateUrl: './fleet-fuel-idleness.component.html',
  styleUrls: ['./fleet-fuel-idleness.component.scss']
})
export class FleetFuelIdlenessComponent implements OnInit {

  report: FleetFuelIdlenessReport = null;
  windowDays = 90;
  windowOptions: { label: string; value: number }[] = [
    { label: '30 dias', value: 30 },
    { label: '60 dias', value: 60 },
    { label: '90 dias', value: 90 },
  ];

  constructor(
    private fleetFuelIdlenessService: FleetFuelIdlenessService,
    private messageUtil: MessageUtil,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.loadReport();
  }

  loadReport(): void {
    this.spinner.show();
    this.fleetFuelIdlenessService.getReport(this.windowDays).subscribe({
      next: (value) => {
        this.report = this.sortGroupsByIdleness(value);
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        const message = error?.error?.message?.includes('problem: ')
          ? error.error.message.split('problem: ')[1]
          : error?.error?.message;
        this.messageUtil.generateMessage('error', 'Erro', message);
      }
    });
  }

  onChangeWindow(): void {
    this.loadReport();
  }

  // Ordena cada grupo por ociosidade (mais tempo sem sair primeiro), tratando
  // embarcações "nunca navegou" como ociosidade máxima — para que o gestor
  // identifique de imediato os barcos parados sem quebrar a ordenação.
  private sortGroupsByIdleness(report: FleetFuelIdlenessReport): FleetFuelIdlenessReport {
    report?.groups?.forEach((group) => {
      group.boats?.sort((a, b) => {
        const aDays = a.neverNavigated ? Number.MAX_SAFE_INTEGER : (a.daysSinceLastSortie ?? -1);
        const bDays = b.neverNavigated ? Number.MAX_SAFE_INTEGER : (b.daysSinceLastSortie ?? -1);
        return bDays - aDays;
      });
    });
    return report;
  }
}